export default "__VITE_ASSET__DKAlymhY__"